export default __webpack_public_path__ + "lifecycle-section.png";